import React from "react";

const H2TipTap = ({ editor, height, width }) => {
  return (
    <svg
      className="cursor-pointer mr-15 pt-5"
      onClick={(e) => {
        e.preventDefault();

        editor.chain().focus().toggleHeading({ level: 2 }).run();
      }}
      width={width || "18"}
      height={height || "18"}
      viewBox="0 0 17 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M11.875 12.1875V0H9.16396V4.78729H3.19208V0H0.5V12.1875H3.19208V7.07131H9.16396V12.1875H11.875Z"
          fill={
            editor.isActive("heading", { level: 2 }) ? "#4652b7" : "#807e7e"
          }
        />
        <path
          d="M17.5625 12.1875V11.2874H15.4252C16.7846 10.3801 17.5232 9.66719 17.5232 8.84629C17.5232 7.88857 16.6353 7.3125 15.5195 7.3125C14.7887 7.3125 14.0108 7.55733 13.5 8.0974L14.1365 8.77428C14.4901 8.43584 14.9458 8.21981 15.543 8.21981C15.9752 8.21981 16.3917 8.42864 16.3917 8.84629C16.3917 9.43676 15.7631 9.93362 13.6179 11.3882V12.1875H17.5625Z"
          fill={
            editor.isActive("heading", { level: 2 }) ? "#4652b7" : "#807e7e"
          }
        />
      </g>
    </svg>
  );
};

export default H2TipTap;
